import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class LocationTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('LocationTypeReference');
  }
}
